import { render, staticRenderFns } from "./BenefitsSection.vue?vue&type=template&id=4246ace1&scoped=true"
import script from "./BenefitsSection.vue?vue&type=script&lang=js"
export * from "./BenefitsSection.vue?vue&type=script&lang=js"
import style0 from "./BenefitsSection.vue?vue&type=style&index=0&id=4246ace1&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4246ace1",
  null
  
)

export default component.exports